/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Video_Files_LabelInputs */



/**
* | output |
* | --- |
* | "Video Files" |
*
* @param {Embed_Captions_Video_Files_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_video_files_label = /** @type {((inputs?: Embed_Captions_Video_Files_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Video_Files_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichiers vidéo")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videodateien")
	if (locale === "it") return /** @type {LocalizedString} */ ("File video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видеофайлы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivos de video")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("動画ファイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो फ़ाइलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ficheiros de vídeo")
	return /** @type {LocalizedString} */ ("Video Files")
});